import { InvalidPage } from 'assessment/pages/components';
import { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import SSOFailurePage from '../pages/SSOFailurePage';
const RipplingIntegration = lazy(() =>
  import(/* webpackChunkName: "PublicAssessment"*/ '../pages/')
);

const routes = [
  { route: '/rippling', component: RipplingIntegration },
  { route: '/sso/failure', component: SSOFailurePage },
];

export const IntegrationRoutes = () => {
  return (
    <Switch>
      {routes.map((item, idx) => {
        const Component = item.component;
        return (
          <Route key={idx} path={item.route}>
            <Component />
          </Route>
        );
      })}
      <Route path="*">
        <InvalidPage />
      </Route>
    </Switch>
  );
};
